import React from 'react';
import propTypes from 'prop-types';
import defaultPropValues from '../helper/defaultPropValues';
import validate from '../utils/label-validator';

import './Youtube.scss';

const Youtube = (props) => {
	const data = { ...defaultPropValues.youtubeProps.data, ...props.data };
	const {
		videoId,
		playlistId,
		videoWidth,
		videoHeight,
		showControls,
		autoPlay,
		loop,
		muted,
		frameborder,
		responsive,
		allowfullscreen
	} = data;
	const id = validate(videoId) ? videoId : playlistId;

	const getParam = (param) => {
		return param === true ? 1 : 0;
	};

	const buildUrl = () => {
		let url = 'https://www.youtube.com/embed';
		if (validate(videoId)) {
			url += `/${id}`;
		} else {
			url += `?listType=playlist&list=${id}`;
		}

		const queryParams = [];
		queryParams.push(`controls=${getParam(showControls)}`);
		queryParams.push(`autoplay=${getParam(autoPlay)}`);
		queryParams.push(`loop=${getParam(loop)}`);
		queryParams.push(`muted=${getParam(muted)}`);
		queryParams.push('rel=0');

		if (url.includes('?')) {
			return `${url}&${queryParams.join('&')}`;
		}

		return `${url}?${queryParams.join('&')}`;
	};

	return (
		<div
			className={`ws-content-row-youtube ${
				getParam(responsive) ? 'responsive' : null
			}`}
		>
			<iframe
				title={id}
				id={id}
				width={videoWidth}
				height={videoHeight}
				src={buildUrl()}
				frameBorder={getParam(frameborder)}
				allowFullScreen={
					getParam(allowfullscreen) === 1 ? 'allowfullscreen' : ''
				}
			/>
		</div>
	);
};

export default Youtube;

export const YoutubeProps = {
	data: propTypes.shape({
		videoId: propTypes.string,
		playlistId: propTypes.string,
		videoWidth: propTypes.string,
		videoHeight: propTypes.string,
		showControls: propTypes.bool,
		autoPlay: propTypes.bool,
		loop: propTypes.bool,
		muted: propTypes.bool,
		frameborder: propTypes.bool,
		allowfullscreen: propTypes.bool
	}).isRequired
};

Youtube.propTypes = YoutubeProps;
